// 消息视图组件 - 整合AI和用户消息

import { memo, type ReactNode } from "react";
import type { Message, Attachment, ToolInvocation } from "@/types/chat";
import { useChatContext } from "@/components/chatview/ChatContext";
import { useChatIdStore } from "@/store/ChatIdStore";
import { AssistantMessage } from "./AssistantMessage";
import { UserMessage } from "./UserMessage";

interface MessageProps {
  chatId: string;
  role: string;
  content: string | ReactNode;
  toolInvocations?: Array<ToolInvocation>;
  attachments?: Array<Attachment | string>;
  isStreaming?: boolean;
  streamingSpeed?: number;
  assistantName?: string;
  avatarUrl?: string;
  streamId?: number;
  quote?: string;
  previousMessage?: Message;
}

export const MessageView = memo(function MessageView({
  role,
  content,
  toolInvocations,
  attachments,
  isStreaming = false,
  streamingSpeed = 30,
  assistantName,
  avatarUrl,
  streamId,
  previousMessage,
  ...props
}: MessageProps) {
  const { setActiveQuote } = useChatContext();
  const { setStartChatId } = useChatIdStore();

  const handleQuote = (quoteContent: string) => {
    setActiveQuote?.(quoteContent);
    if (streamId) {
      setStartChatId(streamId);
    }
  };

  if (role === "assistant") {
    return (
      <AssistantMessage
        content={content}
        toolInvocations={toolInvocations}
        isStreaming={isStreaming}
        streamingSpeed={streamingSpeed}
        assistantName={assistantName}
        avatarUrl={avatarUrl}
        onQuote={handleQuote}
        previousMessage={previousMessage}
      />
    );
  }

  if (role === "user") {
    return (
      <UserMessage
        content={content}
        attachments={attachments}
        quote={props.quote}
      />
    );
  }

  return null;
});
